import script from "./NotesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NotesModal.vue?vue&type=script&setup=true&lang=js"

import "./NotesModal.vue?vue&type=style&index=0&id=787ae82c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-787ae82c"]])

export default __exports__